import cn from 'classnames';
import styles from './ShopsBlock.module.scss';
import { Title } from '../Title';
import { ShopType } from '@/types';
// import { Map } from '../Map';
import { BlockInfo } from '../BlockInfo';
import { ControlledInput } from '../ControlledInput';
import { ChangeEvent, useRef, useState } from 'react';
import { LocationButton } from '../LocationButton';
import { Drawer } from '../Drawer';
import { ShopDrawerContent } from '../ShopDrawerContent';
import { useTranslations } from '@/hooks/useTranslations';
import { useClientTranslations } from '@/hooks/useClientTranslations';
// import { useSelector } from 'react-redux';
// import { selectCity } from '@/store';

type ShopsBlockProps = {
  className?: string;
  shops: ShopType[];
  title?: string;
  selectedCityOnly?: boolean;
};

const normalizeText = (value?: string | null) => (value || '').trim().toLowerCase();

export function ShopsBlock({
  className,
  shops,
  title,
  // selectedCityOnly,
}: ShopsBlockProps) {
  const [shopName, setShopName] = useState('');
  const [shownShop, setShownShop] = useState<ShopType | null>(null);
  const wrapperClassName = cn(styles.wrapper, className);
  const { getTranslations } = useTranslations();
  const t = useClientTranslations();
  const blockInfoRef = useRef<HTMLDivElement>(null);

  const handleShopNameChange = (event: ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    setShopName(value);
  };

  const closeShopInfo = () => {
    setShownShop(null);
  };

  const openShopDrawer = (item: ShopType) => {
    setShownShop(item);
  };

  const normalizedSearch = normalizeText(shopName);


  const filteredShops = shops.filter((shop) => {
    const address = normalizeText(getTranslations(shop.address));
    const town = normalizeText(getTranslations(shop.town));

    return address && town;
  });

  const searchedShops = normalizedSearch
    ? filteredShops.filter((shop) => {
      const address = normalizeText(getTranslations(shop.address));
      const name = normalizeText(getTranslations(shop.name));

      return address.includes(normalizedSearch) || name.includes(normalizedSearch);
    })
    : filteredShops;

  return (
    <div className={wrapperClassName}>
      <Title
        className={styles.title}
        heading
        text={title ?? t.shopsBlock.title}
      />
      <div className={styles.content}>
        <div className={styles.map}>
          {/* <Map /> */}
          <iframe src="https://yandex.ru/map-widget/v1/?um=constructor%3Ace6e903468ce69f9f50579e9c6f2f54c170cf5ff9dc32e9177ac1afdfff5cc82&source=constructor" width="100%" height="100%" frameBorder="0"></iframe>
        </div>
        <div ref={blockInfoRef} className={styles.shopsList}>
          <BlockInfo className={styles.shops}>
            <ControlledInput
              value={shopName}
              onChange={handleShopNameChange}
              placeholder={t.shopsBlock.placeholder}
            />
            {searchedShops.length > 0 && searchedShops.map((item) => (
              <LocationButton
                key={item.id}
                name={getTranslations(item.name)}
                address={getTranslations(item.address)}
                onClick={() => openShopDrawer(item)}
              />
            ))}
          </BlockInfo>
        </div>
      </div>
      <Drawer opened={!!shownShop} closeFn={closeShopInfo} hiddenHeading>
        {shownShop && (
          <ShopDrawerContent
            data={shownShop}
            onClose={() => setShownShop(null)}
          />
        )}
      </Drawer>
    </div>
  );
}
